import React, { ReactNode, useState } from "react";
import { Breadcrumb, TooltipCustom } from "../index";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface TableHeaderProps {
    children?: ReactNode;
    paths?: any;
    title: string;
    buttons?: ReactNode;
    showFilters?: boolean;
    colSize?: number;
    btnColSize?: number;
    btnPositionEnd?: string;
    tooltipIconName?: string;
    tooltipText?: string;
    calendarView?: boolean;
}

const TableHeader: React.FC<TableHeaderProps> = ({
    children,
    paths,
    title,
    buttons,
    showFilters,
    colSize = 6,
    btnColSize = 6,
    btnPositionEnd,
    tooltipIconName,
    tooltipText,
    calendarView,
}) => {
    const { t } = useTranslation();

    return (
        <div>
            <Row className={`${calendarView ? "mb-0 mb-md-3" : "mb-3"} align-items-center gx-2`}>
                <Col lg={colSize}>
                    <div className="d-flex align-items-center">
                        <h2 className="mb-0">{title}</h2>
                        {tooltipText && tooltipIconName && (
                            <TooltipCustom placement="bottom" text={tooltipText} align="center">
                                <i className={`bi bi-${tooltipIconName} fs-4 text-primary ms-3`}></i>
                            </TooltipCustom>
                        )}
                    </div>
                    {paths && <Breadcrumb paths={paths} t={t} />}
                </Col>
                {buttons && (
                    <Col lg={btnColSize} className={btnPositionEnd ? btnPositionEnd : ""}>
                        {buttons}
                    </Col>
                )}
            </Row>
            <div className={`mb-4 ${showFilters ? "" : "d-none"}`}>{children}</div>
        </div>
    );
};

export default TableHeader;
